import Avatar                          from 'react-avatar';
import ActionButton                    from "./ActionButton";
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {useState}                      from "react";
import {Link}                          from "react-router-dom";
import {DateTimeOptionsMediumShort}    from "../../utils/DateTimeOptions";
import NoneValue from "../../components/NoneValue";
import Badge from "../../components/Badge";

function Customer({customer}) {
    const [customerDetailsModal, setCustomerDetailsModal] = useState(false);
    const customerDetailsModalToggle = () => setCustomerDetailsModal(!customerDetailsModal);

    return (
        <>
            <tr>
                <td>

                    {customer.image ? <img src={customer.image}
                                          className="avatar-sm img-thumbnail rounded-circle" alt={"customer"}/>
                        : <Avatar size={35} name={customer.name} round/>}

                </td>
                <td onClick={customerDetailsModalToggle}>
                    <Link className="text-primary">{customer.name}</Link>
                </td>
                <td className="text-muted font-13">{customer.email}</td>
                <td>{customer.phone === "" ? <NoneValue/> : customer.phone}</td>
                {/*<td>*/}
                {/*    {user?.membership === "BASIC" ? (*/}
                {/*        customer.is_vip*/}

                {/*    ): (*/}
                {/*        customer.is_vip ? (*/}
                {/*            <i className="mdi mdi-check mr-2 font-18 text-success" />*/}
                {/*        ) : (*/}
                {/*            <i className="mdi mdi-close mr-2 font-18 text-danger" />*/}
                {/*        )*/}

                {/*    )}*/}
                {/*</td>*/}
                {/*<td>*/}
                {/*    {customer.credit_limit}*/}
                {/*</td>*/}
                <td>{new Date(customer.created).toLocaleString([], DateTimeOptionsMediumShort)}</td>
                <ActionButton customer={customer}/>
            </tr>

            <Modal className={'modal-xl'} isOpen={customerDetailsModal} toggle={customerDetailsModalToggle}>
                <ModalHeader toggle={customerDetailsModalToggle} close={
                    <button className="close" onClick={customerDetailsModalToggle}>
                        &times;
                    </button>
                }>Customer details</ModalHeader>
                <ModalBody>
                    <div className="card-box">
                        <h4 className="header-title">{customer.name}</h4>
                        <p className="sub-header">

                            {customer.image ? <img src={customer.image}
                                                  className="avatar-xl img-thumbnail rounded-circle" alt={"customer"}/>
                                : <Avatar size={95} name={customer.name} round/>}
                        </p>
                        <div className="table-responsive">
                            <table className="table mb-0">

                                <tbody>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Customer ID</td>
                                    <td>{customer.id}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Customer Name</td>
                                    <td>{customer.name}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Email</td>
                                    <td>{customer.email}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Phone</td>
                                    <td>{customer.phone === "" ? <NoneValue/> : customer.phone}</td>
                                </tr>
                                {/*<tr>*/}
                                {/*    <th scope="row"> </th>*/}
                                {/*    <td>VIP</td>*/}
                                {/*    <td>*/}
                                {/*        {user?.membership === "BASIC" ? (*/}
                                {/*        customer.is_vip*/}

                                {/*    ): (*/}
                                {/*             customer.is_vip ? (*/}
                                {/*                 <i className="mdi mdi-check mr-2 font-18 text-success" />*/}
                                {/*             ) : (*/}
                                {/*                 <i className="mdi mdi-close mr-2 font-18 text-danger" />*/}
                                {/*             )*/}

                                {/*         )}*/}
                                {/*    </td>*/}
                                {/*</tr>*/}
                                {/*<tr>*/}
                                {/*    <th scope="row"> </th>*/}
                                {/*    <td>Credit Limit</td>*/}
                                {/*    <td>{customer.credit_limit}</td>*/}
                                {/*</tr>*/}
                                <tr>
                                    <th scope="row"></th>
                                    <td>Address Line 1</td>
                                    <td>{customer.address_line1 === "" ? <NoneValue/> : customer.address_line1}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Address Line 2</td>
                                    <td>{customer.address_line2 === "" ? <NoneValue/> : customer.address_line2}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Country</td>
                                    <td>{customer.country === null ? <NoneValue/> : customer.country}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>State</td>
                                    <td>{customer.state === null ? <NoneValue/> : customer.state}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>City</td>
                                    <td>{customer.city === null ? <NoneValue/> : customer.city}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Pincode</td>
                                    <td>{customer.pincode === "" ? <NoneValue/> : customer.pincode}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>GSTIN</td>
                                    <td>{customer.gstin === "" ? <NoneValue/> : customer.gstin}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>SEZ Customer</td>
                                    <td>
                                        {customer.is_sez ? (
                                            <>
                                                <Badge badge="badge badge-light-success" status="Yes" />
                                                <span className="text-muted font-13 ml-1">
                                                    {customer.sez_type === "SEZ_UNIT" ? "SEZ Unit" : "SEZ Developer"}
                                                </span>
                                            </>
                                        ) : (
                                            <Badge badge="badge badge-light-secondary" status="No" />
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Reverse Charge</td>
                                    <td>
                                        {customer.is_reverse_charge ? (
                                            <Badge badge="badge badge-light-warning" status="Applicable" />
                                        ) : (
                                            <Badge badge="badge badge-light-secondary" status="Not Applicable" />
                                        )}
                                    </td>
                                </tr>
                                {/*<tr>*/}
                                {/*    <th scope="row"></th>*/}
                                {/*    <td>Amount Due</td>*/}
                                {/*    <td>{customer.amount_due}</td>*/}
                                {/*</tr>*/}
                                {/*<tr>*/}
                                {/*    <th scope="row"></th>*/}
                                {/*    <td>Due Date</td>*/}
                                {/*    <td>{customer.due_date}</td>*/}
                                {/*</tr>*/}
                                <tr>
                                    <th scope="row"></th>
                                    <td>Created</td>
                                    <td>{new Date(customer.created).toLocaleString([], DateTimeOptionsMediumShort)}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Updated</td>
                                    <td>{new Date(customer.updated).toLocaleString([], DateTimeOptionsMediumShort)}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>

    );
}

export default Customer;